module.exports = __webpack_public_path__ + "static/media/04.37d58954.jpg";